import { Stack, Textarea, type TextareaProps } from '@chakra-ui/react'
import { css } from '@emotion/react'
import React, { useState } from 'react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import { FormContext, type FormInputType } from '../types'
import CharacterCount from './internal/CharacterCount'

const FormInputTextarea: React.FC<
  {
    input: FormInputType & { type: 'textarea' }
  } & TextareaProps
> = ({ input, ...props }) => {
  const { name: inputName } = input
  const { submitting, onChange } = React.useContext(FormContext)
  const [length, setLength] = useState(input.initialValue?.length ?? 0)
  const handleInput = React.useCallback(
    (e: React.SyntheticEvent<HTMLTextAreaElement>) => {
      const value = (e.target as HTMLInputElement).value.trim()
      onChange(inputName, value)
      setLength(value.length)
    },
    [inputName, onChange]
  )

  return (
    <Stack>
      <Textarea
        minLength={input.minLength ?? 0}
        name={input.name}
        rows={input.rows ?? 5}
        placeholder={input.placeholder ?? ''}
        disabled={submitting || input.disabled}
        defaultValue={input.initialValue ?? ''}
        onChange={handleInput}
        {...props}
        css={css`
        ::placeholder {
          color: ${chakraTokenToVar('fg.subtle')};
        }
      `}
      />
      {typeof input.minLength === 'number' || typeof input.maxLength === 'number' ? (
        <CharacterCount min={input.minLength} max={input.maxLength} length={length} />
      ) : null}
    </Stack>
  )
}

export default FormInputTextarea
